import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';
import { ReactComponent as AgencyPartner } from 'assets/agency-partner-badge.svg';

export const AgencyPartnerBadge = ({
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <figure style={style} className={classNames(className)} onClick={onClick}>
      <AgencyPartner />
    </figure>
  );
};
